import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

import { CChartLineSimple } from '../../../charts/index.js'

export default {
    name: 'ProfessionalCategoryReport',
    data,
    methods,
    mounted,
    watch,
    components: {
        CChartLineSimple
    }
}
